package one.healthium.tasks.ui

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.loco.LString
import one.healthium.loco.resolve
import one.healthium.tasks.domain.DailyTaskModel
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun DailyTasksList(
    modifier: Modifier = Modifier,
    uiModel: DailyTasksUiModel,
    onTaskClicked: (DailyTaskModel) -> Unit,
) {
    LazyColumn(
        modifier = modifier,
        contentPadding = PaddingValues(horizontal = 12.dp)
    ) {
        dailyTaskListItems(
            uiModel = uiModel,
            onTaskClicked = onTaskClicked,
        )
    }
}

fun LazyListScope.dailyTaskListItems(
    uiModel: DailyTasksUiModel,
    contentPadding: PaddingValues = PaddingValues(0.dp),
    onTaskClicked: (DailyTaskModel) -> Unit,
) {
    val tasks = uiModel.uiData
    items(
        count = tasks.size,
        key = { index ->
            val entry = tasks[index]
            if (entry is DailyTaskModel) entry.id
            else entry.toString()
        },
    ) { index ->
        val item = tasks[index]
        if (item is LString) {
            Text(
                modifier = Modifier
                    .animateItem()
                    .padding(contentPadding)
                    .padding(top = 24.dp, start = 4.dp, bottom = 12.dp, end = 4.dp),
                text = item.resolve(),
                style = AppTheme.textStyles.secondary_17_500,
                color = AppTheme.colors.text100,
            )
        } else if (item is DailyTaskModel) {
            DailyTaskItem(
                modifier = Modifier
                    .animateItem()
                    .padding(contentPadding),
                task = item,
                onClick = { onTaskClicked(item) },
            )
            Spacer(Modifier.height(12.dp))
        }
    }
}